export default "__VITE_ASSET__c22791af__"